export interface ApiErrorBody {
  error?: { code?: string; message?: string; issues?: unknown[] };
}

export class ApiClientError extends Error {
  public constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = "ApiClientError";
  }
}

export function isAbortError(error: unknown): boolean {
  return error instanceof Error && error.name === "AbortError";
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const hasJsonBody = Boolean(init.body) && !(init.body instanceof FormData);
  const response = await fetch(path, {
    ...init,
    credentials: "same-origin",
    headers: {
      ...(hasJsonBody ? { "Content-Type": "application/json" } : {}),
      ...init.headers,
    },
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as ApiErrorBody;
    throw new ApiClientError(
      response.status,
      body.error?.code ?? "REQUEST_FAILED",
      body.error?.message ?? `Request failed (${String(response.status)})`,
    );
  }
  if (response.status === 204) return undefined as T;
  return (await response.json()) as T;
}
